module.exports = __webpack_public_path__ + "img/logo-magento.c4d6bd2f.png";